import { createSlice } from '@reduxjs/toolkit';
const columnsDataSlice = createSlice({
  name: 'columnsData',
  initialState: {
    columnsData: {},
    objectsByColumn: {},
    misplacedObjects: {},
    queryTotal: 0
  },
  reducers: {
    setColumnData: (state, action) => {
      const {
        columnId,
        data: newData,
        total,
        hasMore,
        offset,
        getColumnIdFromObject
      } = action.payload;

      // If we have new data (from another search query for example), we want to replace the existing data
      state.columnsData[columnId] = {
        data: newData,
        total,
        hasMore,
        offset,
        columnId
      };
      const objectIds = newData.map(item => item.data.objectId.toString());
      objectIds.forEach(objectId => {
        state.objectsByColumn[objectId] = columnId;
      });
      if (getColumnIdFromObject) {
        newData.forEach(object => {
          const columnFromObjectProperties = getColumnIdFromObject(object);
          if (columnFromObjectProperties && columnFromObjectProperties !== columnId) {
            state.misplacedObjects[object.data.objectId] = {
              destinationColumnId: columnFromObjectProperties
            };
          }
        });
      }
    },
    updateColumnData: (state, action) => {
      var _state$columnsData$co, _state$columnsData$co2;
      const {
        columnId,
        data: newData,
        total,
        hasMore,
        offset,
        getColumnIdFromObject
      } = action.payload;
      const existingData = (_state$columnsData$co = (_state$columnsData$co2 = state.columnsData[columnId]) === null || _state$columnsData$co2 === void 0 ? void 0 : _state$columnsData$co2.data) !== null && _state$columnsData$co !== void 0 ? _state$columnsData$co : [];
      const existingDataIds = existingData.map(item => item.data.objectId);
      const newDataIds = newData.map(item => item.data.objectId);
      const combinedDataIds = new Set([...existingDataIds, ...newDataIds]);

      // If we are updating column data (via a fetch more for example), we want to combine the existing data with the new data
      const combinedData = Array.from(combinedDataIds).map(id => {
        // We prioritize server data over local data since the server data is more up to date
        if (newDataIds.includes(id)) {
          return newData.find(item => item.data.objectId === id);
        } else {
          return existingData.find(item => item.data.objectId === id);
        }
      }).filter(item => item !== undefined);
      state.columnsData[columnId] = {
        data: combinedData,
        total,
        hasMore,
        offset,
        columnId
      };
      combinedDataIds.forEach(objectId => {
        state.objectsByColumn[objectId] = columnId;
      });
      if (getColumnIdFromObject) {
        combinedData.forEach(object => {
          const columnFromObjectProperties = getColumnIdFromObject(object);
          if (columnFromObjectProperties && columnFromObjectProperties !== columnId) {
            state.misplacedObjects[object.data.objectId] = {
              destinationColumnId: columnFromObjectProperties
            };
          }
        });
      }
    },
    setQueryTotal: (state, action) => {
      state.queryTotal = action.payload;
    }
  }
});
export const {
  setColumnData,
  updateColumnData,
  setQueryTotal
} = columnsDataSlice.actions;
export { columnsDataSlice };